.tableWrapper {
  background-color: $ui-black;
  width: 100%;
  height: 100vh;
  padding-inline: 0.5rem;
  padding-block: 0.5rem 1rem;

  display: grid;
  grid-template-rows: 3.5rem auto auto 1fr;
  grid-template-areas:
    'overview'
    'progress'
    'settings'
    'table';
  color: $ui-white;
}

.rundownSelect {
  min-width: min(20rem, calc(100vw - 6rem));
}
